import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("g", null, [
                _createElementVNode("path", { d: "M0 0h48v48H0z" }),
                _createElementVNode("path", {
                  fill: "#000",
                  "fill-rule": "nonzero",
                  d: "M19.712 0C30.6 0 39.425 8.791 39.425 19.636c0 4.843-1.76 9.276-4.678 12.7L48 45.538 45.939 48 32.463 34.612a19.68 19.68 0 0 1-12.75 4.66C8.825 39.272 0 30.48 0 19.636S8.826 0 19.712 0m0 3.219c-9.102 0-16.48 7.35-16.48 16.417s7.378 16.417 16.48 16.417 16.481-7.35 16.481-16.417-7.378-16.417-16.48-16.417"
                })
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}
export default { render: render }